'use client';
import React from 'react';
import { Button } from '@carbon/react';
import Add from '@carbon/icons-react/es/Add.js';
import ArrowLeft from '@carbon/icons-react/es/ArrowLeft.js';
import ArrowRight from '@carbon/icons-react/es/ArrowRight.js';
import Download from '@carbon/icons-react/es/Download.js';
import Launch from '@carbon/icons-react/es/Launch.js';
import LogoGithub from '@carbon/icons-react/es/LogoGithub.js';
import PlayOutline from '@carbon/icons-react/es/PlayOutline.js';
import Save from '@carbon/icons-react/es/Save.js';
import TrashCan from '@carbon/icons-react/es/TrashCan.js';

const ICON_MAP = {
  Add,
  ArrowLeft,
  ArrowRight,
  Download,
  Launch,
  LogoGithub,
  PlayOutline,
  Save,
  TrashCan,
} as const;

type IconName = keyof typeof ICON_MAP;

interface GlobalButtonProps {
  icon?: IconName; // you just pass the name like "Add"
  text: string;
  color?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'ghost'
    | 'danger--primary'
    | 'danger--ghost'
    | 'danger--tertiary'
    | 'tertiary';
  ariaLabel?: string;
  href?: string;
  target?: string;
  style?: React.CSSProperties;
  className?: string;
}

const GlobalButton: React.FC<GlobalButtonProps> = ({
  icon,
  text,
  color = 'primary',
  ariaLabel,
  href,
  target,
  style,
  className,
}) => {
  const IconComponent = icon ? ICON_MAP[icon] : undefined;

  return (
    <Button
      kind={color}
      renderIcon={IconComponent}
      iconDescription={ariaLabel || text}
      href={href}
      target={target}
      style={style}
      className={className}
    >
      <span>{text}</span>
    </Button>
  );
};

export default GlobalButton;
